import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import AuthCallback from '@/components/AuthCallback';
import HomePage from '@/pages/HomePage';
import AdminPage from '@/pages/AdminPage';
import ProductPage from '@/pages/ProductPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import EbookReader from '@/pages/EbookReader';
import AudiobookPlayer from '@/pages/AudiobookPlayer';
import '@/App.css';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
    const location = useLocation();
    // Detect session_id SYNCHRONOUSLY during render to prevent race conditions
    if (location.hash?.includes('session_id=')) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about-the-book" element={<HomePage scrollTarget="about-book" />} />
            <Route path="/about-the-author" element={<HomePage scrollTarget="about-author" />} />
            <Route path="/shop" element={<HomePage scrollTarget="shop" />} />
            <Route path="/ebook" element={<HomePage scrollTarget="account" />} />
            <Route path="/contact" element={<HomePage scrollTarget="contact" />} />
            <Route path="/account" element={<HomePage scrollTarget="account" />} />
            <Route path="/product/:id" element={<ProductPage />} />
            <Route path="/read" element={<EbookReader />} />
            <Route path="/audiobook" element={<AudiobookPlayer />} />
            <Route path="/admin/*" element={<AdminPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
        </Routes>
    );
}

function App() {
    useEffect(() => {
        // Remove platform badge per platform owner's branding requirements
        const badge = document.getElementById('emergent-badge');
        if (badge) badge.remove();
    }, []);

    return (
        <BrowserRouter>
            <AuthProvider>
                <AppRouter />
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
